import {
    TextField,
    Checkbox,
    FormControlLabel,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import { StorageLocationType } from '../../application/types/storageLocation.ts';

const CreateStorageForm = ({ storageData, handleChange }) => {
    return (
        <Box className="w-full max-w-2xl mx-auto bg-white rounded-lg">
            <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                className="text-center mb-6"
            >
                Nytt lagerställe
            </Typography>

            <form className="flex flex-col gap-4">
                <TextField
                    fullWidth
                    label="Namn"
                    name="name"
                    value={storageData.name}
                    onChange={handleChange}
                    required
                />

                <FormControl fullWidth>
                    <InputLabel id="type-select-label">Typ</InputLabel>
                    <Select
                        labelId="type-select-label"
                        id="type-select"
                        value={storageData.type}
                        label="Typ"
                        name="type"
                        onChange={handleChange}
                    >
                        <MenuItem value={StorageLocationType.StorageCabinet}>
                            Läkemedelsskåp
                        </MenuItem>
                        <MenuItem value={StorageLocationType.OperatingRoom}>
                            Operationssal
                        </MenuItem>
                        <MenuItem value={StorageLocationType.AmbulanceBag}>
                            Akutväska
                        </MenuItem>
                    </Select>
                </FormControl>

                {/* <TextField
                    fullWidth
                    label="Digitalt ID"
                    name="digitalId"
                    value={storageData.digitalId}
                    onChange={handleChange}
                /> */}

                <TextField
                    fullWidth
                    label="Plats"
                    name="location"
                    value={storageData.location}
                    onChange={handleChange}
                />

                <TextField
                    fullWidth
                    label="Streckkod"
                    name="barcode"
                    value={storageData.barcode}
                    onChange={handleChange}
                />

                <TextField
                    fullWidth
                    label="Beskrivning"
                    name="description"
                    value={storageData.description}
                    onChange={handleChange}
                    multiline
                    rows={3}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            name="isSatelliteStorage"
                            checked={storageData.isSatelliteStorage}
                            onChange={handleChange}
                            color="primary"
                        />
                    }
                    label="Akutväska"
                />
            </form>
        </Box>
    );
};

export default CreateStorageForm;
